const {
  post,
} = require('../http');

export function apiHelp(params) {
  return post('/f2c/v1/widget/report/issue', params);
}
